import { useIsMobile } from '../../../../hooks/useIsMobile';
import { MobileMenu } from '../mobile-menu/mobile-menu';
import { Menu } from '../menu/menu';
import '../../../../common/css/style.css';

export const NavBar = () => {
  const isMobile = useIsMobile();

  return (
    <nav className="nav-bar-wrapper" aria-label="Основна навігація">
      {isMobile ? <MobileMenu /> : <Menu />}
    </nav>
  );
};
